import type { SignPosition } from "@/app/views/PdfViewer/domain/sign-position.domain.ts";
import { defineStore } from "pinia";

type SignaturePositionState = {
  list: SignPosition[];
};

export const useSignaturePositionStore = defineStore("signature-position", {
  state: (): SignaturePositionState => ({ list: [] }),
  getters: {
    unlinked(): SignPosition[] {
      return this.list.filter(signPosition => !signPosition.isLinked) as SignPosition[];
    },
  },
  actions: {
    setList(list: SignPosition[]) {
      this.list = list;
    },
    async add(signPosition: SignPosition) {
      await signPosition.init();
      this.list = [...this.list, signPosition];
    },
    remove(idStr: string) {
      this.list = this.list.filter(item => item.idStr !== idStr);
    },
  },
});
